/* HALO Friseur-Coaching-Hub (/pages/friseur-coaching), v017d.
   Scroll-Ebene ohne Bibliothek. Inhalte sind ohne Skript sichtbar,
   erst hier wird .hfc--js gesetzt. Bei prefers-reduced-motion bleibt
   alles stehen und sichtbar. */
(function(){
  var root=document.querySelector('[data-hfc]');
  if(!root) return;
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(reduce||!('IntersectionObserver' in window)){
    root.querySelectorAll('[data-fc-field]').forEach(function(f){f.classList.add('is-active');});
    return;
  }
  root.classList.add('hfc--js');
  requestAnimationFrame(function(){requestAnimationFrame(function(){root.classList.add('is-loaded');});});

  /* 1. Einblendung und Zeilen-Masken */
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});},{threshold:0.14,rootMargin:'0px 0px -8% 0px'});
  root.querySelectorAll('.reveal,.hfc-line,[data-clip]').forEach(function(el){io.observe(el);});

  /* 2. Hintergrund wechselt je Abschnitt (data-bg) */
  var bgIo=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){root.style.setProperty('--hfc-bg',e.target.getAttribute('data-bg'));}});},{rootMargin:'-45% 0px -45% 0px'});
  root.querySelectorAll('[data-bg]').forEach(function(s){bgIo.observe(s);});

  /* 3. Problemfelder: aktiv ist immer das Feld, dessen Mitte der Bildmitte am naechsten liegt */
  var fields=[].slice.call(root.querySelectorAll('[data-fc-field]'));
  var count=root.querySelector('[data-fc-count]');
  var current=root.querySelector('[data-fc-current]');
  var activeIdx=-1;
  function setActive(i){
    if(i===activeIdx) return;
    activeIdx=i;
    fields.forEach(function(f,j){f.classList.toggle('is-active',j===i);});
    if(count) count.textContent=(i+1<10?'0':'')+(i+1);
    if(current){var h=fields[i].querySelector('h3');current.textContent=h?h.textContent:'';}
  }
  function pickField(vh){
    if(!fields.length) return;
    var mid=vh*0.5,best=0,bestD=Infinity;
    for(var i=0;i<fields.length;i++){
      var r=fields[i].getBoundingClientRect();
      var d=Math.abs(r.top+r.height/2-mid);
      if(d<bestD){bestD=d;best=i;}
    }
    setActive(best);
  }
  if(fields.length) setActive(0);

  /* 4. Scroll-gebundene Bewegung */
  var pxEls=[].slice.call(root.querySelectorAll('[data-px]'));
  var imgEls=[].slice.call(root.querySelectorAll('[data-img-parallax]'));
  var marquee=root.querySelector('[data-marquee]');
  var lines=[];
  [['[data-fc-steps]','[data-fc-line]','.hfc-step'],['[data-fc-path]','[data-fc-pathline]','.hfc-stage']].forEach(function(c){
    var box=root.querySelector(c[0]);
    if(!box) return;
    lines.push({box:box,line:box.querySelector(c[1]),items:[].slice.call(box.querySelectorAll(c[2]))});
  });
  /* HALO-Kreis: der Kreis steht fest, links wechseln die Texte. Jeder Text setzt
     ein eigenes Gewicht der drei Disziplinen (data-w), der Kreis gleitet dorthin. */
  var halo=root.querySelector('[data-fc-halo]');
  var segs=halo?[].slice.call(halo.querySelectorAll('[data-seg]')):[];
  var discs=halo?[].slice.call(halo.querySelectorAll('[data-disc]')):[];
  var hsteps=halo?[].slice.call(halo.querySelectorAll('[data-hstep]')):[];
  var C=2*Math.PI*150,GAP=6,hIdx=-1;
  function setHalo(i){
    if(i===hIdx) return; hIdx=i;
    hsteps.forEach(function(st,j){st.classList.toggle('is-active',j===i);});
    var w=(hsteps[i].getAttribute('data-w')||'').split(',').map(parseFloat);
    var off=0,lead=-1,max=0.4;
    for(var k=0;k<3;k++){
      var len=Math.max(0,w[k]*C-GAP);
      segs[k].style.strokeDasharray=len.toFixed(1)+' '+(C-len).toFixed(1);
      segs[k].style.strokeDashoffset=(-off).toFixed(1);
      off+=w[k]*C;
      if(w[k]>max){max=w[k];lead=k;}
    }
    segs.forEach(function(sg,k){sg.classList.toggle('is-lead',k===lead);});
    discs.forEach(function(d,k){d.classList.toggle('is-lead',k===lead);});
  }
  var dots=halo?[].slice.call(halo.querySelectorAll('.hfc-hdots span')):[];
  function drawHalo(vh){
    if(!hsteps.length||!segs.length) return;
    var r=halo.getBoundingClientRect();
    var pinH=vh-89,run=r.height-pinH;
    var p=run>0?(89-r.top)/run:0;
    p=Math.max(0,Math.min(0.9999,p));
    var i=Math.floor(p*hsteps.length);
    if(i!==hIdx){
      hsteps.forEach(function(st,k){st.classList.toggle('is-past',k<i);});
      dots.forEach(function(d,k){d.classList.toggle('is-on',k<=i);});
    }
    setHalo(i);
  }
  var mqX=0,lastY=window.scrollY,vel=0,ticking=false;

  function frame(){
    var vh=window.innerHeight,vw=window.innerWidth;
    pxEls.forEach(function(el){
      var r=el.parentElement.getBoundingClientRect();
      if(r.bottom<-200||r.top>vh+200) return;
      var p=(r.top+r.height/2-vh/2)/vh;
      var v=(parseFloat(el.getAttribute('data-px'))||0)/100;
      el.style.transform='translate3d('+(p*v*vw).toFixed(1)+'px,0,0)';
    });
    imgEls.forEach(function(el){
      var host=el.parentElement,r=host.getBoundingClientRect();
      if(r.bottom<-200||r.top>vh+200) return;
      var p=(r.top+r.height/2-vh/2)/(vh+r.height);
      el.style.transform='translate3d(0,'+(p*-18).toFixed(2)+'%,0)';
    });
    lines.forEach(function(o){
      var br=o.box.getBoundingClientRect();
      var prog=Math.max(0,Math.min(1,(vh*0.6-br.top)/br.height));
      if(o.line) o.line.style.transform='scaleY('+prog.toFixed(3)+')';
      o.items.forEach(function(s){s.classList.toggle('is-on',s.getBoundingClientRect().top<vh*0.6);});
    });
    pickField(vh);
    drawHalo(vh);
    ticking=false;
  }
  function onScroll(){
    var y=window.scrollY;vel=y-lastY;lastY=y;
    if(!ticking){ticking=true;requestAnimationFrame(frame);}
  }
  window.addEventListener('scroll',onScroll,{passive:true});
  window.addEventListener('resize',onScroll);
  frame();

  /* 5. Laufband: Grundtempo plus Scroll-Tempo */
  if(marquee){
    var half=0,boost=0,visible=true;
    function measure(){half=marquee.scrollWidth/2;}
    measure();window.addEventListener('resize',measure);
    new IntersectionObserver(function(es){visible=es[0].isIntersecting;}).observe(marquee.parentElement);
    (function loop(){
      if(visible&&half){
        boost+=(Math.min(40,Math.abs(vel))-boost)*0.08;vel*=0.9;
        mqX-=0.6+boost*0.35;
        if(mqX<=-half) mqX+=half;
        marquee.style.transform='translate3d('+mqX.toFixed(1)+'px,0,0)';
      }
      requestAnimationFrame(loop);
    })();
  }
})();
